import { startCase, toLower } from 'lodash'
import React, { FC } from 'react'
import { AbstractEmail } from '../AbstractEmail'
import { AbstractRating } from '../AbstractRating'
import { AbstractType } from '../PresentationContainer/PresentationContainer'
import { OralPresentionStyle } from './styled'

interface OralPresentationProps {
  hasRated: boolean
  abstract: AbstractType
}

export const OralPresentation: FC<OralPresentationProps> = ({ hasRated, abstract }) => {
  const getVimeoUrl = () => {
    const VIMEO_PARAMS = {
      title: '0',
      autoplay: '1',
    }
    const params = new URLSearchParams(VIMEO_PARAMS).toString()
    const videoId = abstract?.vimeo_video ? abstract.vimeo_video.vimeo_id : ''

    return `https://player.vimeo.com/video/${videoId}?${params}`
  }

  return (
    <OralPresentionStyle>
      <div id="vimeoContainer">
        <iframe
          src={getVimeoUrl()}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          title="18_Dyna Medicare Sdn Bhd_Thuasne - The Tread of Life.mp4"
        ></iframe>
        <script src="https://player.vimeo.com/api/player.js"></script>
      </div>
      <section id="bottomSection">
        <div>
          <p className="text-muted mb-2">{abstract.area_of_interest}</p>
          <h4 className="abstractTitle">{abstract.title}</h4>
          <p className="authorName">{startCase(toLower(abstract.presenting_author_name))}</p>
        </div>
        <div className="interactionSection">
          <AbstractEmail email={abstract.presenter_email} />
          <AbstractRating abstractId={abstract.id} defaultRated={hasRated} />
        </div>
      </section>
    </OralPresentionStyle>
  )
}
